export default __webpack_public_path__ + "static/media/pink-lotus.966bbf32.svg";